export default "__VITE_ASSET__Dwn0h7Jo__"